import React from "react";
import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Image,
} from "@react-pdf/renderer";


const styles = StyleSheet.create({
    page: {
        fontSize: 10,
        fontFamily: "Helvetica",
        padding: 20,
        backgroundColor: "#ffffff"
    },

    // Header section - simple white background
    headerSection: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingBottom: 15,
        marginBottom: 15,
        borderBottom: "1px solid #000",
    },
    logoAndCompany: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1,
    },
    logo: {
        width: 50,
        height: 50,
        marginRight:"5px"
    },
    companyInfo: {
        flex: 1,
    },
    companyName: {
        fontSize: 16,
        fontWeight: "bold",
        marginBottom: 3,
        color: "#000",
    },
    companyAddress: {
        fontSize: 10,
        lineHeight: 1.3,
        marginBottom: 1,
        color: "#000",
    },
    contactInfo: {
        fontSize: 9,
        textAlign: "right",
        lineHeight: 1.4,
        color: "#000",
    },

    // OPD BILL title - gray background
    opdTitleSection: {
        backgroundColor: "#888888",
        textAlign: "center",
        paddingVertical: 4,
        marginBottom: 15,
        width: "100%", // ensures full width of the container
    },

    opdTitle: {
        fontSize: 12,
        fontWeight: "bold",
        color: "white",
    },

    // Main content area with barcode and info
    mainContentRow: {
        flexDirection: "row",
        marginBottom: 20,
    },

    // Left side - Barcode and bill info
    leftSection: {
        width: "50%",
        paddingRight: 20,
    },
    barcodeContainer: {
        marginBottom: 15,
    },
    barcode: {
        height: 50,
        backgroundColor: "#000",
        marginBottom: 10,
        // Simple barcode representation
        borderRadius: 0,
    },
    billInfo: {
        fontSize: 10,
        marginBottom: 3,
        color: "#000",
    },

    // Right side - UHID, Encounter ID, Category
    rightSection: {
        width: "50%",
        alignItems: "flex-end",
        paddingLeft: 20,
    },
    rightInfo: {
        fontSize: 10,
        marginBottom: 3,
        textAlign: "right",
        color: "#000",
    },

    // Patient name
    patientNameSection: {
        marginBottom: 10,
    },
    patientName: {
        fontSize: 14,
        fontWeight: "bold",
        color: "#000",
    },

    // Patient details and addresses
    patientDetailsSection: {
        flexDirection: "row",
        marginBottom: 20,
    },
    leftPatientInfo: {
        width: "35%",
        paddingRight: 15,
    },
    patientDetail: {
        fontSize: 10,
        marginBottom: 3,
        color: "#000",
    },
    religionText: {
        fontSize: 10,
        marginBottom: 10,
        color: "#000",
    },
    departmentBox: {
        border: "1px solid #000",
        padding: 5,
        textAlign: "center",
        marginBottom: 10,
    },
    departmentText: {
        fontSize: 10,
        fontWeight: "bold",
        color: "#000",
    },

    // Address section
    addressSection: {
        width: "65%",
        flexDirection: "row",
        justifyContent: "space-between",
    },
    addressBox: {
        width: "48%",
    },
    addressLabel: {
        fontSize: 10,
        fontWeight: "bold",
        marginBottom: 5,
        color: "#000",
    },
    addressText: {
        fontSize: 12,
        lineHeight: 1.4,

        color: "#000",
    },

    // Table
    table: {
        marginBottom: 20,
    },
    tableHeader: {
        flexDirection: "row",
        backgroundColor: "#e6e6e6",
        borderTop: "1px solid #000",
        borderBottom: "1px solid #000",
        borderLeft: "1px solid #000",
        borderRight: "1px solid #000",
    },
    tableRow: {
        flexDirection: "row",
        borderBottom: "1px solid #000",
        borderLeft: "1px solid #000",
        borderRight: "1px solid #000",
        minHeight: 30,
    },
    tableCell: {
        padding: 2,
        fontSize: 10,
        justifyContent: "center",
        display: "flex",
    },
    col1: {
        width: "10%",
        borderRight: "1px solid #000",
        alignItems: "center",
    },
    col2: {
        width: "50%",
        borderRight: "1px solid #000",
        alignItems: "flex-start",
    },
    col3: {
        width: "20%",
        borderRight: "1px solid #000",
        alignItems: "flex-end",
    },
    col4: {
        width: "20%",
        alignItems: "flex-end",
    },
    tableHeaderText: {
        fontWeight: "bold",
        fontSize: 10,
    },

    // Summary section - simple lines
    summarySection: {
        marginTop: 15,
        width: "50%",          // Right half
        alignSelf: "flex-end", // Moves to the right side
    },

    summaryLine: {
        borderBottom: "1px solid #000",
        paddingTop: 6,
        paddingBottom: 6,
        flexDirection: "row",
        justifyContent: "space-between",
        fontSize: 11,
    },

    summaryLabel: {
        color: "#000",
        fontWeight: "normal",
    },

    summaryValue: {
        color: "#000",
        textAlign: "right",
        fontWeight: "normal",
    },

    amountInWordsSection: {
        borderTop: "1px solid #000",
        paddingTop: 10,
        marginTop: 10,
        width: "100%",         // Full width across the page
    },

    amountInWords: {
        flexDirection: "row",
        justifyContent: "space-between",
        fontSize: 11,
        color: "#000",
    },

    amountWordsLabel: {
        fontWeight: "normal",
    },

    amountWordsValue: {
        fontWeight: "normal",
        textAlign: "right",
    },

});

// Simple barcode lines component
const BarcodeLines = () => (
    <View style={{
        height: 50,
        backgroundColor: "#fff",
        flexDirection: "row",
        alignItems: "flex-end",
        justifyContent: "flex-start",
        paddingHorizontal: 5,
    }}>
        {Array.from({ length: 80 }, (_, i) => (
            <View
                key={i}
                style={{
                    width: Math.random() > 0.5 ? 2 : 1,
                    height: Math.random() * 40 + 10,
                    backgroundColor: "#000",
                    marginRight: 0.5
                }}
            />
        ))}
    </View>
);

const numberToWords = (num) => {
    if (!num || isNaN(num)) return "Zero Rupees Only";

    const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const convertHundreds = (n) => {
        let result = '';
        if (n > 99) {
            result += ones[Math.floor(n / 100)] + ' Hundred ';
            n %= 100;
        }
        if (n > 19) {
            result += tens[Math.floor(n / 10)] + ' ';
            n %= 10;
        } else if (n > 9) {
            result += teens[n - 10] + ' ';
            return result;
        }
        if (n > 0) {
            result += ones[n] + ' ';
        }
        return result;
    };

    const amount = Math.floor(parseFloat(num));
    if (amount === 0) return "Zero Rupees Only";

    let result = '';
    let crores = Math.floor(amount / 10000000);
    let lakhs = Math.floor((amount % 10000000) / 100000);
    let thousandsValue = Math.floor((amount % 100000) / 1000);
    let hundreds = amount % 1000;

    if (crores > 0) result += convertHundreds(crores) + 'Crore ';
    if (lakhs > 0) result += convertHundreds(lakhs) + 'Lakh ';
    if (thousandsValue > 0) result += convertHundreds(thousandsValue) + 'Thousand ';
    if (hundreds > 0) result += convertHundreds(hundreds);

    return `Rupees ${result.trim()} Only`;
};

const OpdBillPdf = ({ data, barcodeImage }) => {
    const patient = data?.Group2?.[0] || {};
    const services = data?.Group3 || [];
    const summary = data?.Group4?.[0] || {};

    const netAmount = parseFloat(summary.NET_AMT || 350);
    const receivedAmount = parseFloat(summary.PAY_ON_MODE || 350);
    const dues = netAmount - receivedAmount;

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                {/* Header with logo and company info */}
                <View style={styles.headerSection}>
                    <View style={styles.logoAndCompany}>
                        <Image src="/assets/images/cnci_Logo.png" style={styles.logo} />
                        <View style={styles.companyInfo}>
                            <Text style={styles.companyName}>Chittaranjan National Cancer Institute</Text>
                            <Text style={styles.companyAddress}>
                                Module - 23, Phase II, Webel IT Park, Industrial Area, Durgapur, West Bengal
                            </Text>
                            <Text style={styles.companyAddress}>713208</Text>
                        </View>
                    </View>
                    <View style={styles.contactInfo}>
                        <Text> 033 3506 0600, Ext -1001</Text>
                        <Text> cncinstkol@gmail.com</Text>
                        <Text> https://newtown.cnci.ac.in</Text>
                    </View>
                </View>

                {/* OPD BILL Title */}
                <View style={styles.opdTitleSection}>
                    <Text style={styles.opdTitle}>OPD BILL</Text>
                </View>

                {/* Main content with barcode and patient info */}
                <View style={styles.mainContentRow}>
                    <View style={styles.leftSection}>
                        <View style={styles.barcodeContainer}>
                            <BarcodeLines />
                        </View>
                        <Text style={styles.billInfo}>
                            Bill No : {patient.BILL_NO || "CNCI/25-26/OP9588"}  Bill Date: {patient.BILL_DATE || "23-07-2025 00:25"}
                        </Text>
                        <Text style={styles.billInfo}>
                            Receipt No : {patient.VOUCHER_NO || "CNCI2/25-26/REC8537"}
                        </Text>
                    </View>

                    <View style={styles.rightSection}>
                        <Text style={styles.rightInfo}>
                            UHID:{patient.UHID_ID || "CNCI2251050"}
                        </Text>
                        <Text style={styles.rightInfo}>
                            Encounter ID:{patient.PT_CODE || "CNCI2251050-N4"}
                        </Text>
                        <Text style={styles.rightInfo}>
                            Category : {patient.PATIENT_CATEGORY_NAME || "PRIVATE (CASH)"}
                        </Text>
                    </View>
                </View>

                {/* Patient Name */}
                <View style={styles.patientNameSection}>
                    <Text style={styles.patientName}>
                        {patient.PATIENT_NAME || "RATHINDRA NATH BOSE"}
                    </Text>
                </View>

                {/* Patient details and addresses */}
                <View style={styles.patientDetailsSection}>
                    <View style={styles.leftPatientInfo}>
                        <Text style={styles.patientDetail}>
                            ({patient.GENDER || "Male"}/{patient.AGE || ""})
                        </Text>
                        <Text style={styles.religionText}>
                            Religion - {patient.RELIGION || "Hindu"}
                        </Text>
                        <View style={styles.departmentBox}>
                            <Text style={styles.departmentText}>
                                {patient.ADMISSION_DEPARTMENT || "Radiation Oncology (Radiotherapy)"}
                            </Text>
                        </View>
                    </View>

                    <View style={styles.addressSection}>
                        <View style={styles.addressBox}>
                            <Text style={styles.addressLabel}>Present Address :</Text>
                            <Text style={styles.addressText}>
                                {patient.ADDRESS || "QUARTER NO-3-095, STREET-7,"}
                            </Text>
                            <Text style={styles.addressText}>
                                {patient.PS || "SECTOR-2/D,BOKARO STEEL CITY"}
                            </Text>
                            <Text style={styles.addressText}>
                                {patient.CITY || "SEC-1,BOKARO"},{patient.STATE || "Jharkhand"}
                            </Text>
                            <Text style={styles.addressText}>
                                India - {patient.PINCODE || "827001"}
                            </Text>
                        </View>
                        <View style={styles.addressBox}>
                            <Text style={styles.addressLabel}>Permanent Address :</Text>
                            <Text style={styles.addressText}>
                                {patient.PERMA_ADDRESS || "QUARTER NO-3-095, STREET-7,"}
                            </Text>
                            <Text style={styles.addressText}>
                                {patient.PERMA_PS || "SECTOR-2/D,BOKARO STEEL CITY"}
                            </Text>
                            <Text style={styles.addressText}>
                                {patient.PERMA_DISTRICT || "SEC-1,BOKARO"},{patient.PERMA_STATE || "Jharkhand"}
                            </Text>
                            <Text style={styles.addressText}>
                                India-{patient.PERMA_ZIPCODE || "827001"}
                            </Text>
                        </View>
                    </View>
                </View>

                {/* Services Table */}
                <View style={styles.table}>
                    <View style={styles.tableHeader}>
                        <View style={[styles.tableCell, styles.col1]}>
                            <Text style={styles.tableHeaderText}>SL.NO.</Text>
                        </View>
                        <View style={[styles.tableCell, styles.col2]}>
                            <Text style={styles.tableHeaderText}>NAME</Text>
                        </View>
                        <View style={[styles.tableCell, styles.col3]}>
                            <Text style={styles.tableHeaderText}>RATE</Text>
                        </View>
                        <View style={[styles.tableCell, styles.col4]}>
                            <Text style={styles.tableHeaderText}>AMOUNT</Text>
                        </View>
                    </View>
                    {services.length > 0 ? (
                        services.map((srv, idx) => (
                            <View style={styles.tableRow} key={idx}>
                                <View style={[styles.tableCell, styles.col1]}>
                                    <Text>{idx + 1}</Text>
                                </View>
                                <View style={[styles.tableCell, styles.col2]}>
                                    <Text>{srv.SERVICENAME}</Text>
                                </View>
                                <View style={[styles.tableCell, styles.col3]}>
                                    <Text>{srv.SERVICE_RATE}</Text>
                                </View>
                                <View style={[styles.tableCell, styles.col4]}>
                                    <Text>{srv.SERVICE_AMT}</Text>
                                </View>
                            </View>
                        ))
                    ) : (
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCell, styles.col1]}>
                                <Text>1</Text>
                            </View>
                            <View style={[styles.tableCell, styles.col2]}>
                                <Text>Follow-up consultation</Text>
                            </View>
                            <View style={[styles.tableCell, styles.col3]}>
                                <Text>350.00</Text>
                            </View>
                            <View style={[styles.tableCell, styles.col4]}>
                                <Text>350.00</Text>
                            </View>
                        </View>
                    )}
                </View>

                {/* Summary Section */}
                <View style={styles.summarySection}>
                    <View style={styles.summaryLine}>
                        <Text style={styles.summaryLabel}>NET AMOUNT (₹):</Text>
                        <Text style={styles.summaryValue}>{netAmount.toFixed(2)}</Text>
                    </View>
                    <View style={styles.summaryLine}>
                        <Text style={styles.summaryLabel}>RECEIVED AMOUNT (₹):</Text>
                        <Text style={styles.summaryValue}>{receivedAmount.toFixed(2)}</Text>
                    </View>
                    <View style={styles.summaryLine}>
                        <Text style={styles.summaryLabel}>DUES (₹):</Text>
                        <Text style={styles.summaryValue}>{dues.toFixed(2)}</Text>
                    </View>
                </View>

                {/* Amount in Words */}
                <View style={styles.amountInWordsSection}>
                    <View style={styles.amountInWords}>
                        <Text style={styles.amountWordsLabel}>NET AMOUNT IN WORDS:</Text>
                        <Text style={styles.amountWordsValue}>{numberToWords(netAmount)}</Text>
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default OpdBillPdf;